

import { useEffect, useState } from 'react';

import './DescriptionPopUp.css';
import parse from 'html-react-parser';

import { toPng } from 'html-to-image';


const DescriptionPopUp = ({ jobDescription, jobId, fnClosePopUp }) => {

    const [previewUrl, setPreviewUrl] = useState(null);

    const createImage = () => {
        const a = document.createElement("a");
        a.href = previewUrl;
        a.download = `hiremeworld.com/job/details/${jobId}.png`;
        a.click();
    }

    const [size, setSize] = useState(35);
    const [lineHeight, setLineHeight] = useState(1.4);

    useEffect(() => {
        createPNGImage(parseInt(jobId), jobDescription); 
        console.log("size changed to ", size);
    }, [size]);

    const createPNGImage = async (_jobId, _htmlString) => {
        _htmlString = _htmlString.replaceAll("<p><br></p>", "<br/>");
        var _htmlStringLength = _htmlString.length;
        const config = [
            { id: 10, alignItems: "start", fontSize: 34, marginBottom: 0, lineHeight: 1.9, height: 1080, minHtmlLength: 0, maxHtmlLength: 701, },        
            { id: 11, alignItems: "center", fontSize: 34, marginBottom: 0, lineHeight: 1.9, height: 1080, minHtmlLength: 700, maxHtmlLength: 1200, },
            
            { id: 20, alignItems: "center", fontSize: 30, marginBottom: -10, lineHeight: 1.5, height: 1080, minHtmlLength: 1201, maxHtmlLength: 1300, },
            { id: 25, alignItems: "center", fontSize: 27, marginBottom: 0, lineHeight: 1.6, height: 1190, minHtmlLength: 1301, maxHtmlLength: 1500, },
            { id: 30, alignItems: "center", fontSize: 25, marginBottom: -10, lineHeight: 1.7, height: 1190, minHtmlLength: 1501, maxHtmlLength: 10000000, },
        ]

        var selConfig = config.find(c => _htmlStringLength >= c.minHtmlLength && _htmlStringLength <= c.maxHtmlLength);

        if(process.env.NODE_ENV.toLowerCase() !== 'production') {
            console.log("_htmlStringLength = ", _htmlStringLength, " | selConfig = ", selConfig.id);
        }

        var completeHMTL = `<div style="display: flex; 
                                flex-direction: column;
                                justify-content: center; 
                                align-items: ${ selConfig.alignItems };
                                word-wrap: break-word;
                                gap: 20px;
                                font-size: ${ size }px;">
                            <div>`;
        completeHMTL = completeHMTL + _htmlString + `</div>`;
        completeHMTL += `<div style="
                        text-align: center;
                        width: 100%;"><br/>To apply, please follow this link: <br/>
                        <font color="red">hiremeworld.com/job/details/${_jobId}</font></div>
                        </div>`;

        const temp = document.createElement("div");
        temp.innerHTML = completeHMTL;
        //temp.style.border = "solid 1px black";  // has no effect.
        temp.style.position = "fixed";
        temp.style.left = "-9999px"; // hide offscreen
        temp.style.top = "0";

        const paragraphs = temp.getElementsByTagName("p");
        for (let i = 0; i < paragraphs.length; i++) {
            paragraphs[i].style.lineHeight = lineHeight;  //selConfig.lineHeight;
            paragraphs[i].style.marginBottom = `${ selConfig.marginBottom }px`;
        }
        document.body.appendChild(temp);
        var node = temp.firstElementChild;
    
        const style = document.createElement("style");
        
        var zoom = 1;
        node.style.transform = `scale(${zoom})`;

        node.style.width = `1080px`;
        node.style.height = `1080px`; //`${selConfig.height}px`;

        node.style.paddingLeft = "20px";
        node.style.paddingRight = "20px";

        try {
            const dataUrl = await toPng(node, 
            { 
                cacheBust: true, 
                pixelRatio: 1,
                skipFonts: true, 
            });
            var link = document.createElement('a');
            //link.download = `hiremeworld.com/job/details/${_jobId}.png`;
            //link.href = dataUrl;
            //link.click();
            setPreviewUrl(dataUrl);
        }
        catch(err) {
            console.log(err);
        }
        finally {
            document.body.removeChild(temp);
        }
    }

    createPNGImage(parseInt(jobId), jobDescription);

    const [style, setStyle] = useState({ 
        padding: "5px 55px 5px 20px", 
        overflowY: "auto", 
        // border: "solid 1px black",
        // fontSize: `{${size}px}`, 
        fontSize: "35px",
    });
   

    useEffect(() => {
        const descriptionFontSize = document.getElementById("descriptionFontSize");
        if(descriptionFontSize)
            descriptionFontSize.focus();
    }, []);

    const _setSize = (e) => {
        //var newStyle = {...style};
        //newStyle.fontSize = parseInt(e.target.value) + "px";
        //console.log(newStyle);
        //setStyle(newStyle);
        setSize(e.target.value);
        //setStyle({...style, fontSize: parseInt(e.target.value) + "px"});
    }

    const _setLineHeight = (e) => {
        setLineHeight(e.target.value);
    }

    const closePopUp = () => {
        fnClosePopUp(true);
    }

    return(
    <div className='popup-container' style={{ background: "#d3d3d3a6", wordBreak: 'break-word' }}>
        <div className='dialog-box'>
            <div>
                Font size: <input  name="descriptionFontSize"
                        id="descriptionFontSize"
                        type="number" 
                        value={ size } 
                        onChange={ _setSize }
                    />
                Line height: <input  name="descriptionLineHeight"
                        id="descriptionLineHeight"
                        type="number" 
                        step="0.1"
                        value={ lineHeight } 
                        onChange={ _setLineHeight }
                    />
                <span style={{ 
                    cursor: "pointer",
                    fontSize: "15px",
                    color: "red",
                    fontWeight: "600",
                    borderRadius: "3px",
                    border: "1px solid black",

                    padding: "0 10px",
                    marginLeft: "20px",
                    }} onClick={ closePopUp }>
                    X
                </span>
                <button onClick={ createImage }>Create Image</button>
            </div>
            <div style={
                    style
                }>
                {/* {
                    jobDescription &&
                    parse(jobDescription) 
                } */}

                {   previewUrl && <img src={previewUrl} style={{ width: "350px", border: "solid 1px black", height:"350px" }}/>}


            </div>
        </div>
    </div>
    )
}

export default DescriptionPopUp;